import { Component, OnInit, OnDestroy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AuthService } from '../../services/authorization/auth.service';
import { Router, ActivatedRoute } from '@angular/router';

declare function init_plugins(): any;

@Component({
  selector: 'app-forgotpass',
  templateUrl: './forgotpass.component.html',
  styleUrls: ['../login.component.css']
})
export class ForgotpassComponent implements OnInit {

  email: string;
  message: string;
  errorWarning: boolean;

  constructor(private auth: AuthService, private router: Router) { }

  ngOnInit() {
    init_plugins();
  }

  onNext(form: NgForm) {
    this.email = form.value.email;
    this.auth.forgotPassword(this.email);
    this.router.navigate(['/login']);
  }

  setMyStyle() {
    let styles = {
      'background': '#0000B1',
      'background-image': 'url(""), linear-gradient(#720fff, #9b9b9b)',
      'background-repeat': 'no-repeat'
    };
    return styles;
  }

}
